import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Inbox } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const EmptyStatePanel = ({
  title = 'Sem dados disponíveis',
  description = 'Nenhum registo encontrado.',
  ctaLabel = 'Configurar / Importar dados',
  ctaTo = '/settings?tab=data-migration',
  actionLabel = null,
  onAction = null,
  testId = 'empty-state-panel',
}) => {
  const navigate = useNavigate();

  const handleAction = () => {
    if (typeof onAction === 'function') {
      onAction();
      return;
    }

    if (ctaTo) {
      navigate(ctaTo);
    }
  };

  return (
    <Card className="border-dashed border-slate-300 bg-slate-50/70" data-testid={testId}>
      <CardContent className="flex flex-col items-start gap-4 p-8 text-left">
        <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-white shadow-sm">
          <Inbox className="h-6 w-6 text-slate-500" />
        </div>
        <div className="space-y-2">
          <h3 className="text-xl font-semibold text-slate-900">{title}</h3>
          <p className="max-w-2xl text-sm text-slate-600">{description}</p>
        </div>
        {(actionLabel || ctaLabel) && (
          <Button variant="outline" onClick={handleAction} data-testid={`${testId}-cta-button`}>
            {actionLabel || ctaLabel}
          </Button>
        )}
      </CardContent>
    </Card>
  );
};